import { AnimaliaTaxonomyFilterKey } from '../ports/AnimaliaListRepositoryPort';

export class AnimaliaTaxonomyEntry {
  constructor(
    public readonly level: AnimaliaTaxonomyFilterKey,
    public readonly value: string,
  ) {}
}
